<template>
  <div class="full-height">
    <v-card-title>
      <v-flex tag="h3">
        Manager data
      </v-flex>
    </v-card-title>

    <v-list>
      <v-divider></v-divider>
      <v-list-tile ripple>
        <v-flex xs4 md2>
          <h5><b>Name</b></h5>
        </v-flex>
        <v-flex v-if="managerData" xs9 md10>
          <v-select v-if="toggleChangeCaseManager" :items="users" v-model="selectedCaseManager" label="Select new manager" :disabled="disabled.caseManagerSelect || closed"></v-select>
          <span v-if="!toggleChangeCaseManager">
            {{ managerData.name }}
            <v-btn v-if="!closed" icon flat color="teal" @click="toggleChangeCaseManager = true">
              <v-icon>{{ icon }}</v-icon>
            </v-btn>
          </span>
        </v-flex>
      </v-list-tile>

      <v-list-tile ripple>
        <v-flex xs4 md2>
          <h5><b>Email</b></h5>
        </v-flex>
        <v-flex v-if="managerData" xs9 md10>
          {{ managerData.email || 'N/A' }}
        </v-flex>
      </v-list-tile>
    </v-list>

  </div>
</template>

<script>
  import casesAPI from '@/api/resources/cases'
  import { mapGetters } from 'vuex'

  export default {
    data () {
      return {
        selectedCaseManager: null,
        changed: false,
        toggleChangeCaseManager: false,
        disabled: {
          caseManagerSelect: false
        }
      }
    },
    props: {
      caseid: {
        type: Number,
        required: true
      },
      caseModel: {
        type: Object
      }
    },
    computed: {
      ...mapGetters({
        managerData: 'caseManager',
        users: 'caseManagers'
      }),
      icon () {
        // return this.changed ? 'done' : 'edit'
        return 'edit'
      },
      closed () {
        return this.caseModel.status === 'closed'
      }
    },
    watch: {
      users () {
        this.$store.dispatch('getCaseManager', this.caseid)
      },
      selectedCaseManager (manager) {
        this.changed = false
        this.disabled.caseManagerSelect = true

        casesAPI.updateCaseManager(this.caseid, manager).then(() => {
          this.$store.dispatch('getCaseManager', this.caseid)
          this.$store.dispatch('getCaseLog', this.caseid)
          setTimeout(() => {
            this.toggleChangeCaseManager = false
            this.changed = true
            this.disabled.caseManagerSelect = false
          }, 1000)
        }, () => {})
      }
    },
    methods: {}
  }
</script>

<style>
  .full-height {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// CaseUserCreatedDataTable.vue?6242eec2